import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    typography: {
        htmlFontSize: 16,
    },
    palette: {
        primary: {
            main: '#0BA251',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#1BABD6',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f7fffb',
            paper: '#f7fffb',
        },
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                backgroundColor: '#0BA251',
                '&:hover': {
                    backgroundColor: '#089143',
                },
            },
            containedSecondary: {
                backgroundColor: '#1BABD6',
                '&:hover': {
                    backgroundColor: '#1591B9',
                },
            },
            root: {
                textTransform: 'none',
            },
        },
    },
});